
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { ProxyCmp, initOutputs } from '../lib';
import type { JSX, Components } from '@vime/core/dist/types';

import { 
  VmLoadingScreen 
} from '@vime/core';

import { define } from '../lib';
  

const LoadingScreenInputs: string[] = [
  'playbackReady',
  'hideDots',
];

const LoadingScreenMethods: string[] = [
  
];

const LoadingScreenOutputs: string[] = [
  
];

export type Emitter<T extends ((...args: any[]) => any) | undefined> = EventEmitter<Parameters<Exclude<T, undefined>>[0]>;

export declare interface LoadingScreen extends Components.VmLoadingScreen {}

@ProxyCmp({
  inputs: LoadingScreenInputs,
  methods: LoadingScreenMethods,
})
@Component({
  selector: 'vm-loading-screen',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: LoadingScreenInputs,
  outputs: LoadingScreenOutputs,
})
export class LoadingScreen {
  protected el: HTMLElement;

  

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    define('vm-loading-screen', VmLoadingScreen);
    c.detach();
    this.el = r.nativeElement;
    initOutputs(this, [])
  }
}
  